import gameConfig from "../../../../engines/configs/gameConfig";
import O1HD from "../../../../engines/gameEngine";
import data_control from "../../../../engines/libs/data_control";
import utilsModel from "../../../../engines/libs/utilsModel";
import { backpackUseRuleI } from "../../config/backpackConst";
import { backPackEventMap } from "../../config/BackpackEventConfig";
import { NormalBackpackI } from "../../manager/DefineInterface";
import NormalGameManager from "../../manager/NormalGameManager";
import backpackOpenBase from "../backpackOpenBase";
import clamShellGame from "./clamShellGame";
import clamShellGameClean from "./clamShellGameClean";
import clamShellGameObj from "./clamShellGameObj";

const {ccclass, property} = cc._decorator;

@ccclass
export default class clamShellOpen extends backpackOpenBase {
    canCut:boolean = true;

    clamShellNode:cc.Node = null;

    @property({type:cc.Node,displayName:"次数不足节点"})
    notCountNode:cc.Node = null;

    @property({type:cc.Node,displayName:"按钮"})
    cutBtn:cc.Node = null;

    @property({type:cc.Node,displayName:"刀片节点"})
    daoNode:cc.Node = null;

    @property({type:cc.Prefab,displayName:"蚌壳预制体"})
    objPrefab:cc.Prefab = null;

    private openCountKey:string = "clamShell-cut-key";

    private openCountDayKey:string = "clamShell-cutcount-day-key";

    gameScript:clamShellGame = null;

    buyScript:clamShellGameObj = null;

    onBackPackOpenPrefab(useRule:backpackUseRuleI){
        super.onBackPackOpenPrefab(useRule);
        let backpackItem:NormalBackpackI = backPackEventMap()[useRule.backId];
        let clamShellManager = NormalGameManager._instance.clamShellManager;
        let startData = clamShellManager.getOneStartDataByBackpackItem(backpackItem);
        console.log(startData,"怎么回事??????????")
        if(startData){
            let endData = clamShellManager.getOneTypeEnd(startData.id);
            let node = cc.instantiate(this.objPrefab);
            let ps = node.getComponent(clamShellGameObj);
            ps.bindDate(startData,endData,null,false);
            this.bindNode(node,null);
            this.clamShellNode = node;
        }
    }

    onLoad(){
        this.clamShellNode.setParent(this.node);
        this.clamShellNode.setPosition(cc.v2(0,-100));
        this.clamShellNode.zIndex = 1;
        this.buyScript.canClick = false;
        this.buyScript.updatePrice();
        // console.log(this.cutNode,"?????????????",this.cutNode.isValid,this.cutNode.parent.name,this.cutNode.getPosition(),this.cutNode.height / 2)
    }

    bindNode(node:cc.Node,gameScript:clamShellGame){
        this.clamShellNode = node;
        // this.cutNode.active = true;
        this.buyScript = this.clamShellNode.getComponent(clamShellGameObj);
        this.gameScript = gameScript;
        this.resiveCutCount();
        this.updateCutLabel();
    }

    resiveCutCount(){
        let oldday = O1HD.getServices().localStorageSrv.getStorage(this.openCountDayKey);
        let today = data_control.getCurrDateDayString();
        if(oldday != today){
            this.setOpenCount(0);
            O1HD.getServices().localStorageSrv.setStorage(this.openCountDayKey,today);
        }
    }

    getCutCount(){
        let s = O1HD.getServices().localStorageSrv.getStorage(this.openCountKey) || "0";
        let sCount:number = Number(s);
        if(isNaN(sCount)){
            sCount = 0;
        }
        return sCount;
    }

    setOpenCount(count:number,isPlus:boolean = false){
        let cutCount = this.getCutCount();
        if(isPlus){
            cutCount += count;
        }else{
            cutCount = count;
        }
        O1HD.getServices().localStorageSrv.setStorage(this.openCountKey,cutCount);
    }

    onBtnCut(){
        // 开始切割
        O1HD.getManagers().soundMgr.playSound("anNiu");
        if(this.getCutCount()>=gameConfig.CLAMSHELL_CUT_COUNT){
            // console.log("次数不足");
            utilsModel.loadAndShowVideoAdTrans(()=>{
                this.setOpenCount(0);
                this.updateCutLabel();
            },()=>{

            },null,"观看视频获得切木头次数");
            return;
        }
        if(this.canCut){
            this.canCut = false;
            this.startOpen();
            this.setOpenCount(1,true);
            this.updateCutLabel();
        }
    }

    updateCutBtn(){
        let video = this.cutBtn.getChildByName("videoLayout");
        let normal = this.cutBtn.getChildByName("normalLayout");
        if(this.getCutCount() >= gameConfig.CLAMSHELL_CUT_COUNT){
            video.active = true;
            normal.active = false;
        }else{
            video.active = false;
            normal.active = true;
        }
    }

    updateCutLabel(){
        let lb:cc.Label = this.cutBtn.getChildByName("normalLayout").getChildByName("lb").getComponent(cc.Label);
        lb.string = `开壳(${this.getCutCount()}/${gameConfig.CLAMSHELL_CUT_COUNT})`;
        this.updateCutBtn();
    }

    onBtnBack(){
        O1HD.getManagers().soundMgr.playSound("anNiu");
        if(this.canCut){
            this.node.destroy();
            this.node.removeFromParent();
        }else{
            O1HD.getModules().uiControlModule.showMessageBox("正在切割木头~");
        }
    }

    // 开始切割
    async startOpen(){

        let targetPos:cc.Vec2 = cc.v2(90,-190);
        let initPos:cc.Vec2 = this.daoNode.getPosition().clone();
        let needTime:number = 1.5;
        //@ts-ignore
        cc.tween(this.daoNode).to(needTime,{position:targetPos}).start();
        await new Promise<void>(resolve=>{
            this.scheduleOnce(resolve,needTime);
        });
        let pos = this.clamShellNode.convertToNodeSpaceAR(this.daoNode.convertToWorldSpaceAR(cc.v2()));
        this.daoNode.setParent(this.clamShellNode);
        this.daoNode.scale = 2;
        this.daoNode.setPosition(pos);
        let daoSp:cc.Node = this.daoNode.getChildByName("dao");
        cc.tween(daoSp).to(0.2,{angle:10}).to(0.4,{angle:-10}).to(0.4,{angle:10}).to(0.4,{angle:-10}).to(0.2,{angle:0}).start();
        await new Promise<void>(resolve=>{
            this.scheduleOnce(resolve,1.6);
        });
        pos = this.node.convertToNodeSpaceAR(this.daoNode.convertToWorldSpaceAR(cc.v2()));
        this.daoNode.setParent(this.node);
        this.daoNode.scale = 1;
        this.daoNode.setPosition(pos);
        //@ts-ignore
        cc.tween(this.daoNode).to(needTime,{position:initPos}).start();
        await this.buyScript.openAni();
        this.showClean();
        this.scheduleOnce(()=>{
            this.node.destroy();
            this.node.removeFromParent();
        });
        // let targetY:number = 120 + (this.cutNode.height / 2)
        // let needTime:number = 3;
        // this.cutNode.getComponent(clamShellGameObj).startSawdustAni();
        // this.gameScript.spliceOneSaveObj(this.cutNode);
        // cc.tween(this.cutNode).to(needTime,{y:targetY}).start();
        // this.cutAni.play("cut");
        // O1HD.getManagers().soundMgr.playSound("mutouqiege");
        // this.schedule(()=>{
        //     O1HD.getManagers().soundMgr.playVibrate();
        // },0.1,(needTime/0.1)-5);
        // this.scheduleOnce(()=>{
        //     this.cutNode.getComponent(clamShellGameObj).stopSawdustAni();
        //     this.cutNode.getComponent(clamShellGameObj).loadEndIcon();
        //     this.cutAni.play();
        // },needTime);
        // this.scheduleOnce(()=>{
        //     this.gameScript.showClean(this.cutNode);
        //     this.node.destroy();
        //     this.node.removeFromParent();
        // },needTime + 0.5);
    }

    @property({type:cc.Prefab,displayName:"结算界面"})
    cleanPrefab:cc.Node = null;

    showClean(){
        let cleanNode:cc.Node = cc.instantiate(this.cleanPrefab);
        let cs = cleanNode.getComponent(clamShellGameClean);
        cs.bindNode(this.clamShellNode);
        cleanNode.setParent(O1HD.Canvas());
    }
    
}
